import { useSelector } from "react-redux";

import { getIntegrationCredentialById } from "selectors/integrationCredentials";
import { getBillingDocumentById, getIntegrationCredentials } from "selectors";
import { BillingDocumentType } from "constants/billingDocuments";

export interface XeroDeepLinkOptions {
  credentialsId?: string;
  contactId?: string;
  creditNoteId?: string;
  billingDocumentId?: string;
}

export function useXeroDeepLink({
  credentialsId,
  contactId,
  billingDocumentId,
  creditNoteId,
}: XeroDeepLinkOptions): string | null {
  const integrationCredentials = Object.values(
    useSelector(getIntegrationCredentials),
  );
  const defaultCredential =
    integrationCredentials.length === 1 && integrationCredentials[0];
  const credential =
    useSelector(getIntegrationCredentialById(credentialsId)) ||
    defaultCredential;

  const billingDocument = useSelector(
    getBillingDocumentById(billingDocumentId),
  );

  const shortCode = credential?.organizationShortCode;

  if (!shortCode) {
    return null;
  }

  if (contactId) {
    return `https://go.xero.com/app/${shortCode}/contacts/contact/${contactId}`;
  }

  if (
    billingDocument?.type === BillingDocumentType.RCTI &&
    billingDocument.xeroInvoiceId
  ) {
    return `https://go.xero.com/organisationlogin/default.aspx?shortcode=${shortCode}&redirecturl=/AccountsPayable/Edit.aspx?InvoiceID=${billingDocument.xeroInvoiceId}`;
  }

  if (
    billingDocument?.type === BillingDocumentType.INVOICE &&
    billingDocument.xeroInvoiceId
  ) {
    return `https://go.xero.com/app/${shortCode}/invoicing/view/${billingDocument.xeroInvoiceId}`;
  }

  if (creditNoteId) {
    return `https://go.xero.com/app/${shortCode}/invoicing/credit-note/view/${creditNoteId}`;
  }

  return null;
}
